<div class="spacing-input">
  <input
    [style.border-left]="left ? '1px solid red' : '1px solid cyan'"
    [style.border-right]="right ? '1px solid red' : '1px solid cyan'"
    [style.border-top]="top ? '1px solid red' : '1px solid cyan'"
    [style.border-bottom]="bottom ? '1px solid red' : '1px solid cyan'"
    [value]="value"
    (input)="handleChange($event)"
  />
</div>
